import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {ServicerTransferSummaryList} from '../../../model/servicerTransferSummaryList';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {TransactionWrapper} from '../../../model/transactionWrapper';
import {Constants} from '../../../constants/ebtq-constants';
import {UtilityService} from '../../../services/utility-service';
import {ApproveAndDeleteServicerTransferSummaryList} from '../../../model/approveAndDeleteServicerTransferSummaryList';
import {ApproveAndDeleteServicerTransferSummary} from '../../../model/approveAndDeleteServicerTransferSummary';


@Component({
  standalone: false,
  selector: 'app-service-tranfer-approve-delete',
  templateUrl: './service-tranfer-approve-delete.component.html',
  styleUrls: ['./service-tranfer-approve-delete.component.scss']
})
export class ServiceTranferApproveDeleteComponent implements OnInit {

  approveDeleteServiceTransferList: ServicerTransferSummaryList;
  servicerTransferSummaryList: ServicerTransferSummaryList;
  transactionWrapper: TransactionWrapper;
  cols: any[];
  containsError = false;
  errorMsg: string;
  approveTransferFlag = false;
  approveDeleteFlag: string;

  constructor(private apiService: ApiService, private router: Router, private location: Location,
              private utilityService: UtilityService, private route: ActivatedRoute,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.route.queryParams.subscribe(params => {
      this.approveDeleteFlag = params.flag;
      this.servicerTransferSummaryList = JSON.parse(atob(params.query));
      this.cdr.detectChanges();
    });

    this.cols = [
      {field: 'servicerNumberFrom', header: 'Old Servicer Number'},
      {field: 'servicerNumberTo', header: 'New Servicer Number'},
      {field: 'effectiveDateConverted', header: 'Effective Date'},
      {field: 'portfolioIndicator', header: 'Portfolio Indicator'}

    ];
    this.approveDeleteServiceTransferList = this.apiService.getApprovedDeletedList();
  }

  cancelButton() {
    this.router.navigate(['serviceTransfersResults'], {
      queryParams: {query: btoa(JSON.stringify(this.servicerTransferSummaryList))}
    });
  }

  confimrmApproveOrDelete() {
    const userId = sessionStorage.getItem('userID');
    const approveAndDeleteServicerTransferSummaryList = new ApproveAndDeleteServicerTransferSummaryList();
    this.approveDeleteServiceTransferList.forEach(serviceTransfer => {
      const creationDateVal = this.utilityService.convertDateToMillisec(serviceTransfer.creationDateConverted);
      const effectiveDateVal = this.utilityService.convertDateToMillisec(serviceTransfer.effectiveDateConverted);
      const profileInd = this.utilityService.getProfileCode(serviceTransfer.portfolioIndicator);
      const approveServicerSummary: ApproveAndDeleteServicerTransferSummary = {
        rownum: serviceTransfer.rownum,
        effectiveDate: {date: effectiveDateVal},
        creationDate: {date: creationDateVal},
        servicerNumberTo: serviceTransfer.servicerNumberTo,
        servicerNumberFrom: serviceTransfer.servicerNumberFrom,
        originalCount: serviceTransfer.originalCount,
        processedCount: serviceTransfer.processedCount,
        deletedCount: serviceTransfer.deletedCount,
        portfolioIndicator: profileInd,
        servTransferStatus: serviceTransfer.servTransferStatus,
        submissionId: serviceTransfer.submissionId
      };
      approveAndDeleteServicerTransferSummaryList.push(approveServicerSummary);
    });

    this.transactionWrapper = new TransactionWrapper();

    if (this.approveDeleteFlag != null && this.approveDeleteFlag === 'approve') {
      this.transactionWrapper.queryServiceName = Constants.APPROVE_SERVICER_TRANSFER_LIST;

    } else {
      this.transactionWrapper.queryServiceName = Constants.DELETE_SERVICER_TRANSFER_LIST;
    }
    this.transactionWrapper.parameters[0] = userId;
    this.transactionWrapper.parameters[1] = approveAndDeleteServicerTransferSummaryList;
    this.apiService.executeQuery(this.transactionWrapper).subscribe(() => {
      this.approveTransferFlag = true;
    },
    error => {
      console.log(error);
    });
  }


  showLoanDetails(serviceTransferData) {
    if (serviceTransferData.portfolioIndicator === 'Partial') {
      this.apiService.setServiceTransferForPartial(serviceTransferData);
      this.router.navigate(['partialServiceTransfer'], {
        queryParams: {query: btoa(JSON.stringify(this.servicerTransferSummaryList))}
      });
    }
  }
}
